export default __webpack_public_path__ + "static/media/5.de4a7c99.jpeg";